<div class="modal-header panel-heading" id="ConfirmationModal">
  <div class="darkNavy-fc title1">{{title | translate}}</div>
</div>
<div class="modal-body">
  <div>
    @if (warning == null || warning == '') {
      <span [innerHTML] = "message"></span>
    }
    @if (warning != null && warning != '') {
      <span>{{warning | translate}}</span>
    }
  </div>
</div>
<div class="modal-footer" [hidden]="autoClose == true">
  @if (cancelString != undefined) {
    <button type="button" class="greyBtn" (click)="cancel()" >{{cancelString | translate}}</button>
  }
  @if (showYesButton) {
    <button type="button" class="orangeBtn" [ngStyle]="{'background-color': primaryColor}" [disabled]="warning != null && warning != ''" (click)="confirmed()">{{yes | translate}}</button>
  }
</div>
